module.exports = __webpack_public_path__ + "img/ikon-de.4bd9c4f2.png";